require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-for-the-history-books-eight-famous-programmers-you-should-know.json") })
        }
      }, "path---blog-for-the-history-books-eight-famous-programmers-you-should-know");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-for-the-history-books-eight-famous-programmers-you-should-know!./.cache/json/blog-for-the-history-books-eight-famous-programmers-you-should-know.json
// module id = 830
// module chunks = 231608221292675